import qs from 'qs'
import firstBy from 'thenby'
import {
  checkHttpStatus,
  getApiBaseUrl,
  getApiBaseUrlWithOrg,
  getApiHeadersFromToken
} from '../../../utils/api'
import { addActiveField } from '../../../utils/addActiveField'
import { getNormalizedSkillCheck } from '../../../utils/skills'

// skill check submissions for each student/skill/master course
export const fetchLearningSkillResponses = async function (
  apiData,
  student,
  frameworkSkillId,
  masterCourseIds
) {
  const params = qs.stringify(
    {
      q: {
        framework_skill_id_eq: frameworkSkillId,
        master_course_id_eq: masterCourseIds
      }
    },
    { arrayFormat: 'brackets', encode: false }
  )

  const url = apiData.isMentor
    ? `${getApiBaseUrlWithOrg(apiData.orgId)}/users/${student.id}/framework_skills/responses?${params}`
    : `${getApiBaseUrlWithOrg(apiData.orgId)}/user/framework_skills/responses?${params}`

  try {
    const response = checkHttpStatus(await fetch(url, {
      method: 'GET',
      headers: getApiHeadersFromToken(apiData.token)
    }))

    const data = await response.json()

    // skill checks used to be on a 5 point scale, adjust any old checks to be
    // on the new 4 point scale
    const normalizedResponses = data.map(getNormalizedSkillCheck)

    return normalizedResponses
  }
  catch (e) {
    return []
  }
}

export const fetchLearningSkillMastery = async function (
  apiData,
  student,
  frameworkSkillId,
  masterCourseIds
) {
  const params = qs.stringify(
    {
      q: {
        framework_skill_id_in: [frameworkSkillId],
        master_course_id_eq: masterCourseIds
      }
    },
    { arrayFormat: 'brackets', encode: false }
  )

  const url = apiData.isMentor
    ? `${getApiBaseUrlWithOrg(apiData.orgId)}/users/${student.id}/framework_skills/masteries?${params}`
    : `${getApiBaseUrlWithOrg(apiData.orgId)}/user/framework_skills/masteries?${params}`

  try {
    const response = checkHttpStatus(await fetch(url, {
      method: 'GET',
      headers: getApiHeadersFromToken(apiData.token)
    }))

    const data = await response.json()

    return data.length > 0 ? data[0] : null
  }
  catch (e) {
    return null
  }
}

export const fetchWorkSkillResponses = async function (
  apiData,
  student,
  workSkillId,
  masterCourseIds
) {
  const params = qs.stringify(
    {
      q: {
        with_criteria_id: workSkillId,
        with_master_course_ids: masterCourseIds
      }
    },
    { arrayFormat: 'brackets', encode: false }
  )

  const url = apiData.isMentor
    ? `${getApiBaseUrlWithOrg(apiData.orgId)}/users/${student.id}/artifact_assessments/work_skills_responses?${params}`
    : `${getApiBaseUrlWithOrg(apiData.orgId)}/user/artifact_assessments/work_skills_responses?${params}`

  try {
    const response = checkHttpStatus(await fetch(url, {
      method: 'GET',
      headers: getApiHeadersFromToken(apiData.token)
    }))

    const data = await response.json()

    // BE returns {} when there is not data instead of []
    if (Object.keys(data).length === 0) return []
    return data
  }
  catch (e) {
    return []
  }
}

export const fetchWorkSkillMastery = async function (
  apiData,
  student,
  workSkillId,
  masterCourseIds
) {
  const params = qs.stringify(
    {
      q: {
        with_criteria_id: workSkillId,
        master_course_id_eq: masterCourseIds
      }
    },
    { arrayFormat: 'brackets', encode: false }
  )

  const url = apiData.isMentor
    ? `${getApiBaseUrlWithOrg(apiData.orgId)}/users/${student.id}/artifact_assessments/work_skills_masteries?${params}`
    : `${getApiBaseUrlWithOrg(apiData.orgId)}/user/artifact_assessments/work_skills_masteries?${params}`

  try {
    const response = checkHttpStatus(await fetch(url, {
      method: 'GET',
      headers: getApiHeadersFromToken(apiData.token)
    }))

    const data = await response.json()

    return data.length > 0 ? data[0] : null
  }
  catch (e) {
    return null
  }
}
